import { cn } from '@/lib/utils'
import localeText from '@/locales/datagrid'
import { insensitive } from '@acme/common'
import { Switch, TextField } from '@mui/material'
import { Button } from 'global/components/Button'
import { SearchIcon } from 'lucide-react'
import React from 'react'
import { useTableApiContext } from '../utils/table-context'

export default function ColumnVisibility() {
    const { columns, setColunas } = useTableApiContext()

    const colunasFiltraveis = columns.filter(c => c.hideable !== false)
    const [colunasPesquisa, setColunasPesquisa] = React.useState(
        colunasFiltraveis.map(c => c.field),
    )

    return (
        <div
            className={cn(
                'p-0.5 h-[150px] max-h-[150px]',
                'flex flex-row',
                'border-1 border-b-0',
            )}
        >
            <div
                className={cn(
                    'flex-1 grid',
                    'grid-cols-[repeat(auto-fill,minmax(250px,1fr))]',
                    'grid-rows-[min-content]',
                    'overflow-y-auto overflow-wrap-break-word',
                    'float-left h-full mr-2.5',
                )}
            >
                {colunasFiltraveis
                    .filter(c => colunasPesquisa.includes(c.field))
                    .map(column => {
                        return (
                            <div key={column.field}>
                                <Switch
                                    checked={!column.hide}
                                    onChange={event => {
                                        const value = event.target.checked
                                        setColunas(
                                            columns.map(c =>
                                                c.field === column.field
                                                    ? {
                                                          ...c,
                                                          hide: !value,
                                                      }
                                                    : c,
                                            ),
                                        )
                                    }}
                                />
                                <span style={{ userSelect: 'none' }}>
                                    {column.headerName ?? column.field}
                                </span>
                            </div>
                        )
                    })}
            </div>
            <div className={cn('w-[200px] float-right p-1.5')}>
                <TextField
                    placeholder={localeText.columnsPanelTextFieldLabel}
                    size="small"
                    variant="outlined"
                    autoComplete="off"
                    InputProps={{
                        startAdornment: <SearchIcon className="size-5 mr-2" />,
                    }}
                    onChange={event => {
                        const value = event.target.value
                        setColunasPesquisa(
                            colunasFiltraveis
                                .filter(c =>
                                    insensitive(
                                        c.headerName ?? c.field,
                                    ).includes(insensitive(value)),
                                )
                                .map(c => c.field),
                        )
                    }}
                />
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    fullWidth
                    className="mt-2"
                    onClick={() => {
                        setColunas(prev =>
                            prev.map(c => ({
                                ...c,
                                hide:
                                    !colunasFiltraveis
                                        .map(f => f.field)
                                        .includes(c.field) && c.hideable,
                            })),
                        )
                    }}
                >
                    {localeText.columnsPanelShowAllButton}
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    fullWidth
                    className="mt-1"
                    onClick={() => {
                        setColunas(prev =>
                            prev.map(c => {
                                if (c.hideable !== false)
                                    return {
                                        ...c,
                                        hide: true,
                                    }
                                return c
                            }),
                        )
                    }}
                >
                    {localeText.columnsPanelHideAllButton}
                </Button>
            </div>
        </div>
    )
}
